import styled from 'styled-components/macro';

interface Props {
    className?: string;
    children?: React.ReactNode;
}

export const TableViewRowCell = (props: Props) => {
    return <S_TableViewRowCell className={props.className}>{props.children}</S_TableViewRowCell>;
};

const S_TableViewRowCell = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    gap: 5px;
    align-items: center;
    padding: 0 10px;
`;
